export default "__VITE_ASSET__BfROH2o8__"